// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1178":"1e137159","1670":"4c2bb7c9","6251":"2016a090","6533":"6275adc6","7795":"2016a090"}[chunkId] + ".chunk.css";
};